export default __webpack_public_path__ + "static/media/hht2_Intonation_13.6d03328e.png";